module.exports = __webpack_public_path__ + "static/media/mpti_bck.a7fa8ffe.png";